import PropTypes from 'prop-types';
import React from 'react';

import SignleNeutralIcon from '../../icons/SingleNeutralCircle';

const UserAvatar = ({ className }) => {
  return (
    <SignleNeutralIcon className={className} />
  );
};

UserAvatar.propTypes = {
  className: PropTypes.string,
};

UserAvatar.defaultProps = {
  className: '',
};

export default UserAvatar;
